import { Box, Typography } from "@mui/material";
import { ReactComponent as LoginGradient } from '../../../src/assets/images/login-gradient.svg';
import { t } from 'i18next';

const AccessDenied = () => {
    return (
        <Box className="login-page">
            <Box className="login-container">
                <LoginGradient
                    className="login-container-gradient"
                    aria-hidden="true"
                    focusable="false"
                />

                {/* Left side with branding */}
                <Box className="login-left">
                    <Box className="branding">
                        <img
                            src="./aurora-review-logo.svg"
                            alt={t('login.auroraLogoAlt')}
                            data-testid={`access-denied-img`} />
                    </Box>
                </Box>

                {/* Right side with form */}
                <Box className="login-right">
                    <Box className="login-box">
                        <Typography
                            id="login-title"
                            data-testid="login-title"
                            className="typo-text login-title display2_size"
                        >
                            {t('login.accessRestricted')}
                        </Typography>
                        <Typography
                            id="login-subtitle"
                            className="typo-text body2_size login-subtitle"
                            data-testid={`access-denied-access-restricted-message`}>
                            {t('login.accessRestrictedMessage')}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default AccessDenied;
